export const calculateCorrederaChica = (width, height) => {
  const isHeightExceeded = height > 1601;

  const verticalElements = {
    'Marco': Math.floor(height + 5),
    'Refuerzo Marco': Math.floor(height - 130),
    'Hoja Chica': Math.floor(height - 97),
    'Refuerzo Hoja': Math.floor(height - 244),
    'Junquillo': Math.floor(height - 202),
  };

  const horizontalElements = {
    'Marco': Math.floor(width + 5),
    'Refuerzo Marco': Math.floor(width - 130),
    'Hoja Chica': Math.floor(width / 2 - 13),
    'Refuerzo Hoja': Math.floor(width / 2 - 160),
    'Junquillo': Math.floor(width / 2 - 118),
  };

  const barrasNecesarias = {};
  const largoBarra = 6000; // mm

  // Calcular barras para elementos verticales
  for (const [perfil, largo] of Object.entries(verticalElements)) {
    const cantidadPiezas = (perfil === 'Junquillo' || perfil === 'Hoja Chica' || perfil === 'Refuerzo Hoja') ? 4 : 2;
    const piezasVerticales = Array(cantidadPiezas).fill(largo);
    
    barrasNecesarias[perfil] = {
      cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
      desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
      piezasVerticales,
      piezasHorizontales: [],
      largoTotal: largo * cantidadPiezas
    };
  }

  // Calcular barras para elementos horizontales y combinar con verticales
  for (const [perfil, largo] of Object.entries(horizontalElements)) {
    const cantidadPiezas = (perfil === 'Junquillo' || perfil === 'Hoja Chica' || perfil === 'Refuerzo Hoja') ? 4 : 2;
    const piezasHorizontales = Array(cantidadPiezas).fill(largo);
    
    if (!barrasNecesarias[perfil]) {
      barrasNecesarias[perfil] = {
        cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
        desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
        piezasVerticales: [],
        piezasHorizontales,
        largoTotal: largo * cantidadPiezas
      };
    } else {
      const largoTotalCombinado = (largo * cantidadPiezas) + barrasNecesarias[perfil].largoTotal;
      barrasNecesarias[perfil] = {
        ...barrasNecesarias[perfil],
        cantidadBarras: Math.ceil(largoTotalCombinado / largoBarra),
        desperdicioMm: (Math.ceil(largoTotalCombinado / largoBarra) * largoBarra) - largoTotalCombinado,
        piezasHorizontales,
        largoTotal: largoTotalCombinado
      };
    }
  }

  return {
    vertical: verticalElements,
    horizontal: horizontalElements,
    barrasNecesarias,
    type: 'Corredera Chica',
    photo: "/fotos/corredera.jpg" ,
    heightWarning: isHeightExceeded
  };
};

export const calculateVidriosCorrederaChica = (height, width) => {
  const vidrioHeight = Math.floor(height - 210);
  const vidrioWidth = Math.floor(width / 2 - 126);

  return { vertical: vidrioHeight, horizontal: vidrioWidth };
};
